/* Validates an NTP server */
import { Observable } from 'rxjs';
import { APIPath } from 'src/js/api/route-path-index';
import { BaseController } from 'src/js/controller/base-controller';
import { NtpStatisticsResponse } from 'src/js/model/api/response/ntp-statistics-response';
import { ValidateNtpServerResponse } from 'src/js/model/api/response/validate-ntp-server-response';

export class SettingsDateTimeController extends BaseController {
  /* Retrieves NTP statistics */
  public getNtpStatistics(): Observable<NtpStatisticsResponse> {
    return this.get$(APIPath.ntpStatistics);
  }

  /* Validates an NTP server */
  public validateNtpServer(server: string): Observable<ValidateNtpServerResponse> {
    return this.post$(APIPath.validateNtpServer, { server });
  }
}
